module.exports = __webpack_public_path__ + "media/images/help/step-4-5bc14f960faf54635775d63ce9745487.png";